import {createAction, ActionCreator} from '@packages/utilities/create-action';
import {
  AnyVariableType,
  VariableCollection,
} from '@packages/systems/core/utils/StyleVariables';

export const STYLE_VARIABLES_ORION_APP_VARIABLES_CREATED =
  'STYLE_VARIABLES_ORION_APP_VARIABLES_CREATED' as const;

export const styleVariablesOrionAppVariablesCreated: ActionCreator<
  typeof STYLE_VARIABLES_ORION_APP_VARIABLES_CREATED,
  {
    variables: AnyVariableType[];
    variableCollection: VariableCollection;
  }
> = createAction(STYLE_VARIABLES_ORION_APP_VARIABLES_CREATED);

export const ORION_CONTEXT_ADDED = 'ORION_CONTEXT_ADDED' as const;

export const orionContextAdded: ActionCreator<
  typeof ORION_CONTEXT_ADDED,
  void
> = createAction(ORION_CONTEXT_ADDED);

export const ORION_CURRENT_APP_SET = 'ORION_CURRENT_APP_SET' as const;
export const ORION_SANDBOX_RESET = 'ORION_SANDBOX_RESET' as const;
export const ORION_INITIAL_PROMPT_SET = 'ORION_INITIAL_PROMPT_SET' as const;
